// src/pages/micuenta/Candidatos.jsx
import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { FaArrowLeft } from "react-icons/fa";
import "./candidatos.css";

function Candidatos() {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  if (!user || user.userType !== "employer") {
    return (
      <div className="register-container">
        <div className="register-card">
          <h2 className="register-title">Acceso denegado</h2>
          <p>Debes ser empleador para ver esta sección.</p>
        </div>
      </div>
    );
  }

  // Estado para el filtro por candidato (por ID, en este ejemplo)
  const [searchTerm, setSearchTerm] = useState("");
  // Estado para guardar las aplicaciones del empleador
  const [applications, setApplications] = useState([]);

  // Cargamos las aplicaciones desde localStorage y filtramos por employerId
  useEffect(() => {
    const storedApplied = JSON.parse(localStorage.getItem("appliedJobs")) || [];
    const employerApps = storedApplied.filter(
      (app) => app.employerId === user.id
    );
    setApplications(employerApps);
  }, [user]);

  // Filtrado de candidatos por el ID (puedes ajustar la lógica según tu necesidad)
  const filteredCandidates = applications.filter((app) =>
    app.candidateId.toString().toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleViewComplete = (candId) => {
    alert(`Mostrar detalles completos del candidato con ID: ${candId}`);
  };

  return (
    <div className="register-container">
      <div className="register-card">
        {/* Botón para regresar a Mi Cuenta */}
        <button className="back-button" onClick={() => navigate("/mi-cuenta")}>
          <FaArrowLeft className="back-icon" /> Regresar a Mi Cuenta
        </button>
        
        <h2 className="register-title">Candidatos</h2>
        <p className="subtitle">
          Organiza y revisa las solicitudes de empleo para encontrar el mejor talento.
        </p>

        {/* Filtro */}
        <div className="form-group filter-group">
          <label className="filter-label">FILTROS</label>
          <div className="input-wrapper">
            <input
              type="text"
              className="form-control"
              placeholder="Buscar por ID de candidato..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        <div className="candidates-table">
          <div className="table-header">
            <span className="table-col">Empleo</span>
            <span className="table-col">Candidato (ID)</span>
            <span className="table-col">Estado de la Solicitud</span>
            <span className="table-col">Notas</span>
            <span className="table-col">Ver Completo</span>
          </div>
          {filteredCandidates.length === 0 ? (
            <div className="no-results">
              No hay candidatos que coincidan con tu búsqueda.
            </div>
          ) : (
            filteredCandidates.map((app) => (
              <div key={app.jobId + "-" + app.candidateId} className="table-row">
                <span className="table-col">{app.titulo}</span>
                <span className="table-col">{app.candidateId}</span>
                <span className="table-col">{app.estado}</span>
                <span className="table-col">{app.notes}</span>
                <span className="table-col">
                  <button
                    className="view-complete-btn"
                    onClick={() => handleViewComplete(app.candidateId)}
                  >
                    Ver
                  </button>
                </span>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export default Candidatos;